export const LATESTBLOCKS = 'LATESTBLOCKS';
export const LATESTTXS = 'LATESTTXS';
export const BLOCKSALL = 'VIEWBLOCKSALL';
export const TXSALL = 'VIEWTXSALL';
export const DETAILBLOCK = 'DETAILBLOCK';
export const DETAILTX = 'DETAILTX';
export const CHANGEBLOCK = 'CHANGEBLOCK';
export const CHANGETX = 'CHANGETX';
export const MAINTIME = 'MAINTIME';
export const VIEWTIME = 'VIEWTIME';
export const DAYS = 'DAYS';
export const HOURS = 'HOURS';
export const MINUTES = 'MINUTES';
export const SECONDS = 'SECONDS';
export const REQUEST = 'REQUEST';
export const REQUESTBLOCKS = 'REQUESTBLOCKS';
export const REQUESTTXS = 'REQUESTTXS';
export const SUCCESS = 'SUCCESS';
export const FAILURE = 'FAILURE';
